import { useCreateUploadTokenMutation } from "./__generated__/api";

export default function useUploadAttachment() {
    const [uploadAttachment] = useCreateUploadTokenMutation();

    const uploader = async (file: File) => {
        const meta = await uploadAttachment({
            variables: {
                attachment: {
                    filename: file.name,
                    size: file.size,
                    mimeType: file.type,
                },
            },
        });

        if (!meta.data?.createUploadToken || meta.data.createUploadToken?.error) {
            return {
                name: file.name,
                mimeType: file.type,
                error: meta.data?.createUploadToken?.error ?? "Error uploading file",
            };
        }
        const { url, token } = meta.data.createUploadToken;

        const response = await fetch(url, {
            method: "POST",
            body: file,
            credentials: "include",
        });

        if (response.status !== 201) {
            return {
                name: file.name,
                mimeType: file.type,
                error: "Error uploading file. Server did not return 201",
            };
        }

        const json = await response.json() as {url: string};

        return {
            name: file.name,
            mimeType: file.type,
            url: json.url,
            token,
        };
    };

    return [uploader];
}
